/**
 * <s-delivery-estimate data-min-days="7" data-max-days="10" data-locale="en"> — fills
 * [data-delivery-range] with "Mon DD, YYYY to Mon DD, YYYY", counting business days
 * (Mon–Fri) from today in the shopper's time zone, then reveals itself. Public holidays are
 * not modeled, so the copy reads "Estimated". Stays hidden if anything is missing.
 */
class SDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const target = this.querySelector('[data-delivery-range]');
    const min = Number(this.dataset.minDays);
    const maxRaw = Number(this.dataset.maxDays);
    const max = Math.max(min, maxRaw);
    if (!target || !Number.isFinite(min) || !Number.isFinite(maxRaw)) return;

    const addBusinessDays = (start, days) => {
      const date = new Date(start);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }
      return date;
    };

    const locale = this.dataset.locale || document.documentElement.lang || 'en';
    const format = new Intl.DateTimeFormat(locale, { month: 'short', day: '2-digit', year: 'numeric' });
    const today = new Date();
    const from = format.format(addBusinessDays(today, min));
    const to = format.format(addBusinessDays(today, max));
    const joiner = this.dataset.joiner || ' to ';
    target.textContent = `${from}${joiner}${to}.`;
    this.hidden = false;
  }
}

if (!customElements.get('s-delivery-estimate')) customElements.define('s-delivery-estimate', SDeliveryEstimate);
